import { useNavigate } from 'react-router-dom';
import Icon from '@/assets/setpasswordsuccess/icon.svg';
import './index.less';

export default function SetPasswordSuccess({ setCurrentPage }) {
  const navigate = useNavigate();

  // 跳转注册页面
  const navigateToLogin = () => {
    if (setCurrentPage) {
      setCurrentPage('login');
      return;
    }
    navigate('/login');
  };

  return (
    <div className="setpasswordsuccessbox">
      <img src={Icon} className="iocnlogo" alt="" />
      <div className="text">Password Changed</div>
      <button className="btn btn-primary continue_btn" onClick={navigateToLogin}>
        Login
      </button>
    </div>
  );
}
